// removed by extract-text-webpack-plugin
module.exports = {"add-margin":"styles__add-margin___3l7H0","toast__svg":"styles__toast__svg___MkoLg","toast":"styles__toast___yqlCa","slideInLeft":"styles__slideInLeft___3k6eC","toast__icon":"styles__toast__icon___15exi","toast__type":"styles__toast__type___2NU8b","toast__message":"styles__toast__message___1IYKw","toast__content":"styles__toast__content___2Bv0N","toast__close":"styles__toast__close___2GfKd","toast--green":"styles__toast--green___v8Xe0","toast--blue":"styles__toast--blue___3Esyq","toast--yellow":"styles__toast--yellow___3AU0M","toast--error":"styles__toast--error___3IFXZ","fadeOut":"styles__fadeOut___3zSI3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Toast/v1/styles.css
// module id = 2687
// module chunks = 0